<template>
  <div class="container-list" style="position:relative">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        角色编辑
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="110px">
      <el-row :gutter="20">
        <el-col :span="6" v-if="!$route.query.id">
          <el-form-item  label="角色编码" prop="role_key">
            <el-input v-model="form.role_key" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="角色名称" prop="role_value">
            <el-input v-model="form.role_value" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="排序" prop="role_sort">
            <el-input v-model.number="form.role_sort" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="系统内置" prop="role_system">
            <el-select v-model="form.role_system" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="角色分类" prop="role_type">
            <el-select v-model="form.role_type" filterable placeholder="请选择">
              <el-option v-for="item in roletype" :label="item.mc_name" :value="item.mc_id+''"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用户类型" prop="role_user_type">
            <el-select v-model="form.role_user_type" placeholder="请选择">
              <el-option v-for="item in usertype" :label="item.mc_name" :value="item.mc_id+''"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="数据范围" prop="role_data">
            <el-input v-model="form.role_data" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="单位编号"  prop="company_id">
            <el-select v-model="form.company_id" filterable placeholder="请选择">
              <el-option
                v-for="item in units"
                :key="item.c_company_num"
                :label="item.c_name"
                :value="item.c_company_num"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-left: 40px; width:800px" v-if="tree.length">
        <div class="pd15" >菜单列表：<el-checkbox
          :indeterminate="isIndeterminate"
          v-model="allCheck"
          @change="handleCheckAllChange"
          style="margin-bottom: 10px"
          class="mt20"
        >全选</el-checkbox>
        </div>
        
            <el-form-item  style="float:left" label-width="0" v-for="item in tree">
          <div class="flex">
            <div style="margin-right: 30px">
              <el-checkbox-group v-model="form.rolemenu">
                <el-checkbox :label="item.menu_key" name="menu">{{item.menu_name}}</el-checkbox>
              </el-checkbox-group>
            </div>
         
          </div>
        </el-form-item>
      
      </div>

    </el-form>
         <div style="position:absolute;bottom:0; right:0" class="ml20 ">
        <div class="l-btn" @click="onSubmit">保存</div>
        <div class="l-btn ml20" @click="$router.back()">返回</div>
      </div>

  </div>
</template>

<script>
import { addUser } from "../../api/user";
import { getMenu } from "../../api/common";
export default {
  data() {
    return {
      allCheck: false,
      isIndeterminate: false,
      form: {
        role_key: "",
        role_value: "",
        role_sort: "",
        role_system: "",
        role_type: "",
        role_user_type: "",
        role_data: "",
        company_id: "",
        remark: "",
        rolemenu: [],
      },
      menu: [],
      func: [],
      menus: [],
      tree: [],
      funcs: [],
      units: [],
      usertype: [],
      roletype: [],
    };
  },
  created() {
 
    this.$post("/menu/findall",{page:1,limit:100}).then((res) => {
      let data = res.data.list;

      data.forEach((it) => {
        this.tree.push(it);
      });
    
    });
    this.$get("/role/roleandtype").then((res) => {
      this.usertype = res.data.usertype;
      this.roletype = res.data.roletype;
    });
    this.$get("/user/roleandcompany").then((res) => {
      this.units = res.data.company;
    });
    this.$post("/user/queryrolebycompanyid").then((res) => {
      this.copNums = res.data.role_list;
    });
    if (this.$route.query.id) {
      this.$get("/role/rolemenushow/" + this.$route.query.id).then((res) => {
        for (var i in this.form) {
          if (res.data.listbasic[i]) {
            this.form[i] = res.data.listbasic[i];
          }
        }
        res.data.list.forEach((it) => {
          this.form.rolemenu.push(it.menu_code);
        });
        this.$set(this.form, "rolemenu", this.form.rolemenu);
        log(this.form);
      });
    }
  },
  methods: {
    changeFile(file, fileList) {
      log(file, fileList);
    },

    handleCheckAllChange(val) {
      this.form.rolemenu = val ? this.menus.concat(this.funcs) : [];
      //this.func = val ? this.funcs : [];
      this.isIndeterminate = false;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    save() {
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      let api = this.$route.query.id ? "/role/updaterole" : "/role/addrole";
      this.$post(api, this.form)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
									message: "保存成功",
									type: 'success',
									duration: 700,
								});
          this.$router.back();
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
</style>